'use client';

import { c as _c } from "react/compiler-runtime";
import { Tabs } from '@base-ui/react/tabs';
import { useState } from 'react';
import type { SidebarItem } from '../../../../../types';
import { PanelBody } from '../panel-body';
import './sidebar-panel.scss';
type SidebarPanelProps = {
  items: SidebarItem[];
  selectionPath: string[];
};
export function SidebarPanel(t0) {
  const $ = _c(14);
  const {
    items,
    selectionPath
  } = t0;
  const [activeItemId, setActiveItemId] = useState(items[0]?.id);
  let t1;
  if ($[0] !== items) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = item => <Tabs.Tab key={item.id} value={item.id} nativeButton={!item.panel.overviewLink} render={item.panel.overviewLink ? <a href={item.panel.overviewLink.href} rel={item.panel.overviewLink.openInNewTab ? "noopener noreferrer" : undefined} target={item.panel.overviewLink.openInNewTab ? "_blank" : undefined} aria-label={item.label} /> : undefined} className="sidebar-panel__tab sparky-u-theme-typography-body-lg-bold" onMouseEnter={() => setActiveItemId(item.id)}>{item.label}</Tabs.Tab>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Tabs.List aria-label="Submenu categories" className="sidebar-panel__tabs">{t1}</Tabs.List>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== items || $[6] !== selectionPath) {
    let t4;
    if ($[8] !== selectionPath) {
      t4 = item_0 => <Tabs.Panel key={item_0.id} value={item_0.id} className="sidebar-panel__panel"><PanelBody panel={item_0.panel} selectionPath={[...selectionPath, item_0.label]} showOverviewLink={false} /></Tabs.Panel>;
      $[8] = selectionPath;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = items.map(t4);
    $[5] = items;
    $[6] = selectionPath;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== activeItemId || $[11] !== t2 || $[12] !== t3) {
    t4 = <Tabs.Root value={activeItemId} onValueChange={setActiveItemId} orientation="vertical" className="sidebar-panel sparky-u-display-flex sparky-u-width-100">{t2}{t3}</Tabs.Root>;
    $[10] = activeItemId;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}